import { render, staticRenderFns } from "./LaborForm.vue?vue&type=template&id=60ee0ef6&scoped=true"
import script from "./LaborForm.vue?vue&type=script&lang=js"
export * from "./LaborForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./LaborForm.vue?vue&type=style&index=2&id=60ee0ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ee0ef6",
  null
  
)

export default component.exports